export default "__VITE_ASSET__3$CXADir__"